import React from "react";
import { Filter, Search as SearchIcon } from "lucide-react";

const Filters = ({ groupId, setGroupId, roleId, setRoleId, searchTerm, setSearchTerm }) => (
  <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-white/20 p-6 mb-6">
    <div className="flex items-center space-x-2 mb-4"><Filter className="w-5 h-5 text-gray-600" /><h3 className="text-lg font-semibold text-gray-900">Filters</h3></div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="relative">
        <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          placeholder="Search admins..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
        />
      </div>
     
      <select value={roleId} onChange={e => setRoleId(e.target.value)} className="px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500">
        <option value="all">All Roles</option>
        <option value="1">Admin</option>
        <option value="2">Users</option>
      </select>
    </div>
  </div>
);

export default Filters;
